<template>
    <component :is="component">
        <slot/>
    </component>
</template>

<style>
    @font-face {
        font-family: 'regularFont';
        src: url('./assets/fonts/neris-light.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldFont';
        src: url('./assets/fonts/neris-black.otf') format('opentype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'lightMontserratFont';
        src: url('./assets/fonts/montserrat-light.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'mediumMontserratFont';
        src: url('./assets/fonts/montserrat-medium.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'regularMontserratFont';
        src: url('./assets/fonts/montserrat-regular.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldMontserratFont';
        src: url('./assets/fonts/montserrat-bold.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'regularRobotoFont';
        src: url('./assets/fonts/roboto-regular.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldRobotoFont';
        src: url('./assets/fonts/roboto-bold.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'regularMyriadProFont';
        src: url('./assets/fonts/myriadpro-regular.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldMyriadProFont';
        src: url('./assets/fonts/myriadpro-bold.otf') format('opentype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'boldAntomFont';
        src: url('./assets/fonts/antom-bold.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'regularPoppinsFont';
        src: url('./assets/fonts/poppins-regular.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldPoppinsFont';
        src: url('./assets/fonts/poppins-bold.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'regularStaraFont';
        src: url('./assets/fonts/stara-regular.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldStaraFont';
        src: url('./assets/fonts/stara-bold.otf') format('opentype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'regularCustom1Font';
        src: url('./assets/fonts/poppins2-regular.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldCustom1Font';
        src: url('./assets/fonts/trajan-bold.otf') format('opentype');
        font-weight: bold;
    }

    body {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top;
    }

    .application {
        font-family: regularFont;
        background: transparent !important;
        font-size: 14px;
    }

    .swal2-container {
        font-family: regularFont;
    }

    .swal2-hide-cancel-button .swal2-cancel {
        display: none !important;
    }

    .text-bold {
        font-family: boldFont;
    }

    .text-regular {
        font-family: regularFont;
    }

    .container {
        padding: 20px !important;
        height: 100%;
    }

    button {
        font-family: boldFont;
        text-transform: initial !important;
    }

    button:not(.radius-inline) {
        border-radius: 25px !important;
    }

    a {
        text-decoration: underline;
    }

    .body-scroll-active {
        position: fixed;
        top: 0;
        left: 0;
        width: 100% !important;
        height: 100% !important;
        overflow: auto !important;
        overflow-x: hidden !important;
    }

    .cursor-hover {
        cursor: pointer;
    }

    .cursor-hover:hover {
        opacity: 0.8;
    }

    .app-container {
        padding: 0 20px !important;
        background-color: #000;
    }

    .app-error-info {
        font-size: 14px;
        color: #888;
        text-align: center;
        padding: 20px;
    }

    .app-error-info>div {
        margin-top: 5px;
    }

    .app-title-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
    }

    .app-screen-title {
        font-size: 18px;
        text-align: left;
    }

    .app-title {
        font-size: 16px;
        text-align: left;
        margin-bottom: 5px;
    }

    .app-title-icon {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .app-title-icon img {
        height: 22px;
    }

    .app-tabs {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
    }

    .app-tabs>div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border-radius: 0;
        height: 30px;
        font-family: boldFont;
    }

    @media (max-width: 450px) {
        .app-tabs>div {
            font-size: 11px;
            line-height: 11px;
        }
    }

    .app-tabs>div>span {
        margin-top: -2px;
    }

    .app-tabs>div:first-child {
       border-top-right-radius: 0 !important;
       border-bottom-right-radius: 0 !important;
    }

    .app-tabs>div:last-child {
       border-top-left-radius: 0 !important;
       border-bottom-left-radius: 0 !important;
    }

    .app-arrows-title {
        font-family: boldFont;
        font-size: 16px;
        padding-bottom: 10px;
    }

    .app-arrows-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: boldFont;
        font-size: 16px;
        padding-bottom: 10px;
    }

    .app-arrows-top>div:first-child {
        padding: 0 10px;
    }

    .app-arrows-top>div:last-child {
        padding: 0 10px;
    }

    .app-arrows-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: boldFont;
        font-size: 16px;
        padding: 5px 0 10px;
    }

    .app-arrows-bottom-points {
        display: flex;
        align-items: center;
    }

    .app-arrows-bottom-points>div {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        margin: 0 5px;
    }

    .app-arrows-icon {
        font-size: 25px;
    }

    .app-footer-buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 5px 20px 80px;
        margin: 0 -20px 0;
    }

    .app-footer-buttons button {
        width: 100%;
    }

    .app-subtitle {
        font-size: 15px;
        text-align: center;
    }

    .app-info {
        padding: 20px 0;
        text-align: center;
    }

    .app-clipboard {
        padding-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
    }

    .app-clipboard > div {
        cursor: pointer;
        padding-bottom: 3px;
    }

    .app-clipboard b {
        margin-right: 5px;
    }

    .app-clipboard-icon {
        margin-left: 5px;
    }

    .app-video {
        text-align: center;
        padding: 20px 0 0;
    }

    .app-image {
        text-align: center;
        padding: 40px 0 20px;
    }

    .app-image img {
        width: 200px;
        max-width: 100%;
    }

    .app-footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 10px 0 20px;
    }

    .app-footer>div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .app-footer button svg:first-child {
        margin-right: 7px;
    }

    .app-footer button {
        width: 100%;
        margin: 5px 0;
        font-size: 16px !important;
        height: 40px;
    }

    .app-margin-space {
        margin: 20px 0;
    }

    .form-row {
        padding: 5px 0;
        position: relative;
    }

    .form-row-only-parent {
        padding-top: 15px !important;
        padding-bottom: 0 !important;
    }

    .form-row-title {
        margin-bottom: 5px;
        display: flex;
    }

    .form-row-title-parent {
        padding: 5px 0;
        display: flex;
        font-family: boldFont;
        font-size: 15px;
    }

    .form-row .v-input {
        padding: 0 !important;
        margin: 0 !important;
    }

    .form-row>div:not(.form-row-field-average):not(.v-textarea):not(.v-input--radio-group):not(.video-container):not(.audio-component):not(.input-slider):not(.input-scale):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.radio-group):not(.checkbox-container) {
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input:not(.v-textarea):not(.v-input--radio-group):not(.video-container):not(.audio-component):not(.input-slider):not(.input-scale):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.radio-group):not(.checkbox-container) .v-input__control {
        margin: 0 !important;
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input:not(.v-textarea):not(.v-input--radio-group):not(.video-container):not(.audio-component):not(.input-slider):not(.input-scale):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.radio-group):not(.checkbox-container) .v-input__slot {
        margin: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .form-row .v-input:not(.v-input--slider) .v-input__slot {
        background-color: #fff !important;
    }

    .form-row .input-slider:not(.input-slider-custom) .v-slider__thumb {
        border-color: #fff!important;
        background-color: #fff!important;
    }

    .form-row .v-text-field--outline>.v-input__control>.v-input__slot {
        background-color: #fff !important;
    }

    .form-row .v-input:not(.v-textarea):not(.v-input--radio-group):not(.video-container):not(.audio-component):not(.input-slider):not(.input-scale):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.radio-group):not(.checkbox-container) input {
        margin: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
    }

    .form-row .v-input:not(.v-textarea):not(.v-input--radio-group):not(.video-container):not(.audio-component):not(.input-slider):not(.input-scale):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.radio-group):not(.checkbox-container) .v-input__append-inner {
        margin-top: 7px !important;
    }

    .form-row .input-slider-legend {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: -5px 0 10px;
    }

    .form-row .input-slider {
        margin-top: -5px;
    }

    .form-row .input-slider-legend-value {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
    }

    .form-row .input-slider-legend-value-circle {
        width: 25px;
        height: 25px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-family: boldFont;
    }

    .form-row .input-slider-legend-label {
        font-size: 9px;
        width: 100%;
        text-align: center;
    }

    .form-row .v-input--radio-group .v-input__slot {
        border-radius: 4px;
        padding: 10px;
    }

    .form-row .v-input--radio-group .v-input__control {
        min-width: 100%;
    }

    .form-row-field-average {
        margin-top: 10px;
        font-family: boldFont;
    }

    .form-row .input-scale {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 5px;
    }

    .form-row .input-scale .v-input__slot {
        padding: 0 5px;
    }

    .form-row .input-scale .v-input {
       width: 100%;
    }

    .form-row .input-scale-label {
        font-size: 11px;
        min-width: 50px;
        width: 50px;
        max-width: 50px;
    }

    .form-row .input-scale-label:last-child {
        text-align: right;
    }

    .form-row .input-scale .v-input .v-input--radio-group__input {
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .form-row .input-scale .v-input:not(.v-input--slider) .v-input__slot {
        background-color: transparent !important;
    }

    .form-row .input-scale .v-label {
        color: #fff;
    }

    .form-row .input-scale .v-radio {
        display: flex;
        flex-direction: column;
    }

    .form-row .input-scale .v-input--selection-controls__input {
        margin: 0;
    }

    .form-row .input-scale .v-icon {
        color: #fff;
    }

    .form-row .input-scale .v-input .v-radio {
        width: 100%;
        margin: 0;
    }

    .form-row textarea {
        padding: 12px;
        min-height: 100px;
    }

    .form-row .v-select .v-input__icon svg {
        height: 16px;
    }

    .select-search-title {
        justify-content: center;
        font-family: boldFont;
        padding-bottom: 0;
    }

    .select-search-list-search {
        font-size: 14px;
    }

    .select-search-list {
        height: 55vh;
        overflow: auto;
        overflow-x: hidden;
    }

    .select-search-list>div {
        cursor: pointer;
        padding: 5px;
    }

    .select-search-list-center>div {
        justify-content: center;
    }

    .select-search-list>div.active {
        background-color: #ddd;
        border-radius: 5px;
    }

    .form-row .v-autocomplete .v-select__slot>input  {
        pointer-events: none !important;
    }

    .form-row .v-select__selections {
        padding: 0 !important;
    }

    .form-row .v-select__selection--comma {
        margin: 0 !important;
    }

    .form-row-switch {
        display: flex;
        align-items: center;
        background-color: rgb(0 0 0 / 40%);
        padding: 5px 10px;
        border-radius: 6px;
        margin: 10px 0;
    }

    .form-row-switch>span {
        margin-right: 10px;
    }

    .form-row-switch .v-input--switch__track {
        color: rgba(255,255,255,.38);
    }

    .form-row-switch .v-input--switch {
        margin: 0;
    }

    .form-row-input-password input {
        padding-right: 20px !important;
    }

    .form-row-password-icon {
        position: absolute;
        top: 40px;
        right: 10px;
        cursor: pointer;
        color: #888;
    }

    .form-row .audio-component {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }

    .form-row-photo-caption {
        margin: 15px 0 -5px;
        text-align: center;
    }

    .form-row.input-radius .v-input__slot {
        border-radius: 4px;
    }

    .form-row .v-textarea .v-input__slot {
        border-radius: 4px;
    }

    .form-row .v-textarea textarea {
        border-radius: 4px;
        border: 2px solid transparent;
    }

    .form-row-datepicker-inline {
        display: flex;
        background-color: #fff;
        color: #000;
    }

    .form-row-datepicker-inline .vue-scroll-picker {
        margin: 0 10px;
    }

    .form-row-datepicker-inline .vue-scroll-picker-item {
        height: 30px;
        line-height: 30px;
    }

    .form-row-datepicker-inline .vue-scroll-picker-layer .top,
    .form-row-datepicker-inline .vue-scroll-picker-layer .bottom {
        border-color: #d0e5df;
    }

    .v-dialog {
        margin: 0 auto !important;
    }

    .checkbox-container {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }

    .checkbox-container.disabled {
        pointer-events: none;
        opacity: 0.3;
    }

    .checkbox-container-virtual-list {
        padding: 0;
        font-size: 14px;
        line-height: 14px;
    }

    @media (max-width: 400px) {
        .checkbox-container-virtual-list {
            font-size: 13px;
            line-height: 13px;
        }
    }

    .checkbox-container-box {
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 22px;
        width: 22px;
        max-width: 22px;
        min-height: 22px;
        height: 22px;
        max-height: 22px;
        border: 1px solid #fff;
        border-radius: 4px;
        font-size: 12px;
    }

    .v-select-list .v-list__tile__title {
        display: flex;
        white-space: initial;
        overflow: initial;
        height: auto;
        font-size: 14px;
        line-height: 14px;
    }

    .component-select-close {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px;
        margin: -10px 0;
        color: #888;
    }

    .app-buttons-flex {
        padding-top: 20px;
    }

    .app-buttons-flex>div {
        width: calc(50% - 20px);
        margin: 10px;
        height: 120px;
        font-family: boldFont;
        text-transform: initial;
        font-size: 18px;
        border-radius: 25px;
        cursor: pointer;
        text-align: center;
    }

    .app-step-tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 0;
    }

    .app-step-tabs>div {
        padding: 5px 5px 0;
        width: 100%;
    }

    .app-step-tabs>div>div {
        width: 100%;
        border-bottom: 1px solid;
        text-align: center;
        padding-bottom: 5px;
    }

    .app-content-has-scroll,
    .app-content-has-scroll body,
    .app-content-has-scroll .application,
    .app-content-has-scroll .v-content {
        height: 100%;
    }

    .app-content-has-scroll .app-container {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .app-content-has-scroll .app-content-scroll-element {
        height: 100%;
        overflow: auto;
        width: calc(100% + 40px);
        margin: 0 -20px;
        padding: 0px 20px 10px;
    }

    .app-content-hidden {
        visibility: hidden;
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1;
    }

    /* Radio group */
    .radio-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
        background-color: #fff;
        padding: 8px;
        border-radius: 4px;
    }

    .radio-label {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #0000008a;
        font-size: 16px;
    }

    .radio-input {
        display: none;
    }

    .radio-custom {
        width: 20px;
        height: 20px;
        border: 2px solid #0000008a;
        border-radius: 50%;
        margin-right: 10px;
        position: relative;
        transition: background-color 0.3s, border-color 0.3s;
    }

    .radio-custom::after {
        content: '';
        width: 10px;
        height: 10px;
        background-color: #82b1ff;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        transition: transform 0.2s ease-in-out;
    }

    .radio-input:checked + .radio-custom {
        border-color: #82b1ff;
    }

    .radio-input:checked + .radio-custom::after {
        transform: translate(-50%, -50%) scale(1);
    }

    /* Json classes */
    /* Input light */
    .input-theme-light .form-row-title {
        color: #8b9390 !important;
    }

    .input-theme-light .v-input__control {
        background-color: #f7f9f8 !important;
    }

    .input-theme-light .v-input__slot {
        border-width: 1px !important;
        border-color: #ddd !important;
    }

    .input-theme-light textarea {
        border: 1px solid #ddd;
    }

    .input-theme-light .v-text-field>.v-input__control>.v-input__slot:before,
    .input-theme-light .v-text-field>.v-input__control>.v-input__slot:after {
        display: none !important;
    }

    /* Input dark */
    .input-theme-dark .form-row-title {
        color: #fff !important;
    }

    .input-theme-dark .v-input__control {
        background-color: #2e2e2e !important;
        border-radius: 4px;
    }

    .input-theme-dark .v-input__slot {
        border-width: 1px !important;
        border-color: #2e2e2e !important;
    }

    .input-theme-dark input,
    .input-theme-dark textarea {
        color: #fff !important;
    }

    .input-theme-dark .v-select .v-select__selections {
        color: #fff !important;
    }

    .input-theme-dark.form-row .v-text-field--outline>.v-input__control>.v-input__slot,
    .input-theme-dark.form-row .v-textarea .v-input__slot {
        background-color: #2e2e2e !important;
    }

    .input-theme-dark .v-text-field>.v-input__control>.v-input__slot:before,
    .input-theme-dark .v-text-field>.v-input__control>.v-input__slot:after {
        display: none !important;
    }

    /* Grid */
    .app-content-grid {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        margin-right: -5px;
        margin-left: -5px;
    }

    .app-content-grid>div {
        grid-column: span 12;
        padding-right: 5px;
        padding-left: 5px;
    }

    .app-content-grid-cols-2 {
        grid-column: span 6 !important;
    }

    /* Montserrat light */
    .app-container-font-montserrat-light .form-row-title {
        font-family: lightMontserratFont;
    }

    .app-container-font-montserrat-light .application {
        font-family: lightMontserratFont;
    }

    .app-container-font-montserrat-light .swal2-container {
        font-family: lightMontserratFont;
    }

    .app-container-font-montserrat-light .text-bold {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .text-regular {
        font-family: lightMontserratFont;
    }

    .app-container-font-montserrat-light .app-subtitle {
        font-family: lightMontserratFont;
    }

    .app-container-font-montserrat-light .app-info {
        font-family: lightMontserratFont;
    }

    .app-container-font-montserrat-light button {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .app-tabs>div {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .app-arrows-title {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .app-arrows-top {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .app-arrows-bottom {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .form-row-title-parent {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .form-row .input-slider-legend-value-circle {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .app-buttons-flex>div {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .form-row-field-buttons span {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .select-search-title {
        font-family: mediumMontserratFont;
    }

    .app-container-font-montserrat-light .form-row-field-average {
        font-family: mediumMontserratFont;
    }

    /* Montserrat */
    .app-container-font-montserrat .form-row-title {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .application {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .swal2-container {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .text-bold {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .text-regular {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .app-subtitle {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .app-info {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat button {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-tabs>div {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-arrows-title {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-arrows-top {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-arrows-bottom {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .form-row-title-parent {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .form-row .input-slider-legend-value-circle {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-buttons-flex>div {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .form-row-field-buttons span {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .select-search-title {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .form-row-field-average {
        font-family: boldMontserratFont;
    }

    /* Roboto */
    .app-container-font-roboto .form-row-title {
        font-family: regularRobotoFont;
    }

    .app-container-font-roboto .application {
        font-family: regularRobotoFont;
    }

    .app-container-font-roboto .swal2-container {
        font-family: regularRobotoFont;
    }

    .app-container-font-roboto .text-bold {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .text-regular {
        font-family: regularRobotoFont;
    }

    .app-container-font-roboto .app-subtitle {
        font-family: regularRobotoFont;
    }

    .app-container-font-roboto .app-info {
        font-family: regularRobotoFont;
    }

    .app-container-font-roboto button {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .app-tabs>div {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .app-arrows-title {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .app-arrows-top {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .app-arrows-bottom {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .form-row-title-parent {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .form-row .input-slider-legend-value-circle {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .app-buttons-flex>div {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .form-row-field-buttons span {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .select-search-title {
        font-family: boldRobotoFont;
    }

    .app-container-font-roboto .form-row-field-average {
        font-family: boldRobotoFont;
    }

    /* MyriadPro */
    .app-container-font-myriadpro .form-row-title {
        font-family: regularMyriadProFont;
    }

    .app-container-font-myriadpro .application {
        font-family: regularMyriadProFont;
    }

    .app-container-font-myriadpro .swal2-container {
        font-family: regularMyriadProFont;
    }

    .app-container-font-myriadpro .text-bold {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .text-regular {
        font-family: regularMyriadProFont;
    }

    .app-container-font-myriadpro .app-subtitle {
        font-family: regularMyriadProFont;
    }

    .app-container-font-myriadpro .app-info {
        font-family: regularMyriadProFont;
    }

    .app-container-font-myriadpro button {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .app-tabs>div {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .app-arrows-title {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .app-arrows-top {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .app-arrows-bottom {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .form-row-title-parent {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .form-row .input-slider-legend-value-circle {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .app-buttons-flex>div {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .form-row-field-buttons span {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .select-search-title {
        font-family: boldMyriadProFont;
    }

    .app-container-font-myriadpro .form-row-field-average {
        font-family: boldMyriadProFont;
    }

    /* Antom */
    .app-container-font-antom .text-bold {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .text-bold.app-subtitle {
        font-family: regularFont;
    }

    .app-container-font-antom button {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .app-tabs>div {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .app-arrows-title {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .app-arrows-top {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .app-arrows-bottom {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .form-row-title-parent {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .form-row .input-slider-legend-value-circle {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .app-buttons-flex>div {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .form-row-field-buttons span {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .select-search-title {
        font-family: boldAntomFont;
    }

    .app-container-font-antom .form-row-field-average {
        font-family: boldAntomFont;
    }

    /* Poppins */
    .app-container-font-poppins .form-row-title {
        font-family: regularPoppinsFont;
    }

    .app-container-font-poppins .application {
        font-family: regularPoppinsFont;
    }

    .app-container-font-poppins .swal2-container {
        font-family: regularPoppinsFont;
    }

    .app-container-font-poppins .text-bold {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .text-regular {
        font-family: regularPoppinsFont;
    }

    .app-container-font-poppins .app-subtitle {
        font-family: regularPoppinsFont;
    }

    .app-container-font-poppins .app-info {
        font-family: regularPoppinsFont;
    }

    .app-container-font-poppins button {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .app-tabs>div {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .app-arrows-title {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .app-arrows-top {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .app-arrows-bottom {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .form-row-title-parent {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .form-row .input-slider-legend-value-circle {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .app-buttons-flex>div {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .form-row-field-buttons span {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .select-search-title {
        font-family: boldPoppinsFont;
    }

    .app-container-font-poppins .form-row-field-average {
        font-family: boldPoppinsFont;
    }

    /* Stara */
    .app-container-font-stara .form-row-title {
        font-family: regularStaraFont;
    }

    .app-container-font-stara .application {
        font-family: regularStaraFont;
    }

    .app-container-font-stara .swal2-container {
        font-family: regularStaraFont;
    }

    .app-container-font-stara .text-bold {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .text-regular {
        font-family: regularStaraFont;
    }

    .app-container-font-stara .app-subtitle {
        font-family: regularStaraFont;
    }

    .app-container-font-stara .app-info {
        font-family: regularStaraFont;
    }

    .app-container-font-stara button {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .app-tabs>div {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .app-arrows-title {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .app-arrows-top {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .app-arrows-bottom {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .form-row-title-parent {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .form-row .input-slider-legend-value-circle {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .app-buttons-flex>div {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .form-row-field-buttons span {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .select-search-title {
        font-family: boldStaraFont;
    }

    .app-container-font-stara .form-row-field-average {
        font-family: boldStaraFont;
    }

    /* Custom1 */
    .app-container-font-custom1 {
        font-family: regularCustom1Font;
    }

    .app-container-font-custom1 .form-row-title {
        font-family: regularCustom1Font;
    }

    .app-container-font-custom1 .application {
        font-family: regularCustom1Font;
    }

    .app-container-font-custom1 .swal2-container {
        font-family: regularCustom1Font;
    }

    .app-container-font-custom1 .text-bold {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .text-regular {
        font-family: regularCustom1Font;
    }

    .app-container-font-custom1 .app-subtitle {
        font-family: regularCustom1Font;
    }

    .app-container-font-custom1 .app-info {
        font-family: regularCustom1Font;
    }

    .app-container-font-custom1 button {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .app-tabs>div {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .app-arrows-title {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .app-arrows-top {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .app-arrows-bottom {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .form-row-title-parent {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .form-row .input-slider-legend-value-circle {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .app-buttons-flex>div {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .form-row-field-buttons span {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .select-search-title {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 .form-row-field-average {
        font-family: boldCustom1Font;
    }

    .app-container-font-custom1 button,
    .app-container-font-custom1 input,
    .app-container-font-custom1 optgroup,
    .app-container-font-custom1 select,
    .app-container-font-custom1 textarea {
        font-family: regularCustom1Font;
    }
</style>

<script>
    import VuebaseLayout from './layouts/VuebaseLayout'
    import Utils from './services/Utils'

    export default {
        name: 'App',
        components: {
            VuebaseLayout
        },
        computed: {
            component() {
                return VuebaseLayout
            }
        },
        beforeMount: function () {
            Utils.initialize()
        }
    }
</script>
